import React, { useCallback, useState } from "react";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

import useAnalytics from "@app/util/contexts/useAnalytics";

import useListView from "../../utils/useListView";

import Pagination from "./Pagination";

interface Props {
  allowedPageSizes?: number[];
  showSizeChanger?: boolean;
  totalRecords: number;
}

const ListViewPagination = <T extends AnyEntity>({
  allowedPageSizes,
  showSizeChanger,
  totalRecords,
}: Props) => {
  const analyticIssuer = useAnalytics();

  const {
    goToPage,
    viewState: { range },
  } = useListView<T>();
  const [pageSize, setPageSize] = useState(range.endRow - range.startRow);
  const currentPage = Math.floor(range.startRow / pageSize);

  const handleGoToPage = useCallback(
    (page: number) => {
      goToPage(page - 1, pageSize);
      analyticIssuer?.clicked(["Pagination Page"]);
    },
    [analyticIssuer, pageSize, goToPage]
  );

  const handleChangePageSize = useCallback(
    (newPageSize: number) => {
      setPageSize(newPageSize);
      const newPageNumber = Math.floor((currentPage * pageSize) / newPageSize);
      goToPage(newPageNumber, newPageSize);
    },
    [currentPage, goToPage, pageSize]
  );

  return (
    <Pagination
      allowedPageSizes={allowedPageSizes}
      currentPage={Math.floor(range.startRow / pageSize) + 1}
      onChange={handleGoToPage}
      onPageSizeChange={showSizeChanger ? handleChangePageSize : undefined}
      pageSize={pageSize}
      totalRecords={totalRecords}
    />
  );
};

export default ListViewPagination;
